import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect, Field } from 'formik'
import { useFlag } from '../../FeatureFlag/FeatureFlag'

import Error from '../../Error/Error'
import Radio from '../../Form/Radio/Radio'
import { SavedAddressLabel } from '../../SavedAddressLabel/SavedAddressLabel'
import Input from '../../Form/Input/Input'

import { useSavedAddressUpdater } from './use-saved-address-updater'
import { CannedDeliveryInstructions } from './CannedDeliveryInstructions'

import './SavedAddressPicker.css'
import { ContactlessDeliveryInstructions } from './ContactlessDeliveryInstructions'

const SavedAddressPickerImpl = ({ savedAddresses = [], field, formik: { setFieldValue } }) => {
  const { error } = useSavedAddressUpdater({
    savedAddresses,
    savedAddressGuid: field.value
  })

  const enableCannedDeliveryUpdateNotes = useFlag('oo-v3-canned-delivery-instructions', false)

  const selectedAddress = savedAddresses.find(address => address.guid === field.value)

  useEffect(() => {
    if (!enableCannedDeliveryUpdateNotes) return
    /**
     * check for selectedAddress.deliveryInfo.notes presence for when value is null
     * application will throw fatal error if field is set to null value
     **/
    if (
      selectedAddress &&
      selectedAddress.deliveryInfo &&
      selectedAddress.deliveryInfo.notes
    ) {
      setFieldValue(
        'contactlessCustomerDeliveryInfoNotes',
        selectedAddress.deliveryInfo.notes
      )
    }
  }, [selectedAddress, setFieldValue, enableCannedDeliveryUpdateNotes])

  if (savedAddresses.length === 0) {
    return <p>No Saved Addresses</p>
  }

  return (
    <React.Fragment>
      {savedAddresses.map(address => (
        <div key={address.guid}>
          <Field
            data-testid='saved-address'
            component={Radio}
            id={`${field.name}_saved_address_${address.guid}`}
            name={field.name}
            label={<SavedAddressLabel savedAddress={address} />}
            value={address.guid}
          />
        </div>
      ))}

      {selectedAddress && enableCannedDeliveryUpdateNotes && (
        <div styleName='savedAddressDeliveryInstructionsOverride'>
          <Field
            component={Input}
            data-testid='contactless_customer_delivery_info_notes'
            type='text'
            id='contactless_customer_delivery_info_notes'
            label='Update Delivery Instructions'
            name='contactlessCustomerDeliveryInfoNotes'
          />
          <CannedDeliveryInstructions
            content={(
              <div>
                <ContactlessDeliveryInstructions />
                <div styleName='emphasized'>Note: This will replace your saved instructions for this order only.</div>
              </div>
            )}
          />
        </div>
      )}
      {error && <Error error={error} />}
    </React.Fragment>
  )
}

const FieldShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
})

SavedAddressPickerImpl.propTypes = {
  savedAddresses: PropTypes.arrayOf(PropTypes.shape({
    guid: PropTypes.string.isRequired
  })),
  field: FieldShape.isRequired,
  formik: PropTypes.object
}

export const SavedAddressPicker = connect(SavedAddressPickerImpl)
